<li class="list-item btn {{stateClass}}" {{#if allowTooltip}}title="{{item.name}}"{{/if}}>
  <h3>{{item.code}} - {{item.name}}</h3>
  <p>{{#if item.family}}{{item.family}}{{else}}-{{/if}} / {{#if item.amount}}{{item.amount}}{{/if}} {{#if
    item.unit}}{{item.unit}}{{/if}}</p>
</li>
